import React from "react";
import classes from "./Button.module.scss";
import { Link } from "react-router-dom";

const ButtonLink = ({
  children,
  className,
  //   onClick,
  //   type,
  style,
  //   disabled,
  href,
  ...props
}) => {
  return (
    <Link
      {...props}
      to={href}
    //   href={href}
      className={`${classes.btn} ${className}`}
      //   onClick={onClick}
      //   type={type}
      style={style}
      //   disabled={disabled || false}
    >
      {children}
    </Link>
  );
};

export default ButtonLink;
